!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("jotai/vanilla"), require("optics-ts")) : "function" == typeof define && define.amd ? define(["exports", "jotai/vanilla", "optics-ts"], t) : t((e || self).jotaiOptics = {}, e.vanilla, e.opticsTs);
}(this, function (e, t, n) {
  function r(e) {
    if (e && e.__esModule) return e;
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function (n) {
      if ("default" !== n) {
        var r = Object.getOwnPropertyDescriptor(e, n);
        Object.defineProperty(t, n, r.get ? r : {
          enumerable: !0,
          get: function get() {
            return e[n];
          }
        });
      }
    }), t.default = e, t;
  }
  var o = /*#__PURE__*/r(n),
    i = function i(e, t, n) {
      return (t.has(n) ? t : t.set(n, e())).get(n);
    },
    u = new WeakMap(),
    a = function a(e, t) {
      return "Traversal" === e._tag ? o.collect(e)(t) : "Prism" === e._tag ? o.preview(e)(t) : o.get(e)(t);
    };
  e.focusAtom = function (e, n) {
    return r = function r() {
      var r = n(o.optic());
      return t.atom(function (t) {
        var n = t(e);
        return n instanceof Promise ? n.then(function (e) {
          return a(r, e);
        }) : a(r, n);
      }, function (t, n, i) {
        var u = "function" == typeof i ? o.modify(r)(i) : o.set(r)(i),
          a = t(e);
        return n(e, a instanceof Promise ? a.then(u) : u(a));
      });
    }, f = n, c = i(function () {
      return new WeakMap();
    }, u, e), i(r, c, f);
    var r, f, c;
  };
});